<div fxFlex fxLayout="row" class="flexBoxMinimumSizing buttonContainer {{rightBorder?'rightBorder':''}}">
    <div class="verticalLine"></div>
    <div fxFlex [class]="selected?'selectedMenuButton':'menuButton'">
        <div class="iconContainer" [style.height.px]="heightForIcon">
            <ng-content></ng-content>
        </div>
    </div>
</div>

